import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
} from '@plone/volto/helpers';
import { blocks } from '~/config';
//import { ResouFolderHeader } from './Common';
import { map } from 'lodash';
// import { useMediaQuery } from 'react-responsive';
// import { MediaQueryConfig } from '../../../helpers/GlobalStyle/GlobalStyle';
import './FolderBlockView.css';
import { FolderTitle, HelmetTitle, HorizontalRule } from './Common';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
});

/**
 * Folder Block view component class.
 * @function FolderBlockView
 * @param {Object} content Content object.
 * @returns {string} Markup of the component.
 */
const FolderBlockView = ({ content, intl }) => {
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);

  //   const isSP = useMediaQuery({
  //     query: MediaQueryConfig.SP_AND_TABLET,
  //   });

  return (
    <div className="FolderBlockView">
      <HelmetTitle pageTitle={content.title} />
      <div className="folderBlockInner">
        <div className="folderBlockHeader">
          <HorizontalRule className="hr" />
          <FolderTitle
            title={content.title}
            title_sp1={content.title_sp1}
            title_sp2={content.title_sp2}
          />
          {/* <HorizontalRule className="hr" />
          <FolderTitle
            title={content.title}
            title_sp1={null}
            title_sp2={null}
          /> */}
        </div>
        <div className="folderBlockBody">
          {map(content[blocksLayoutFieldname].items, (block) => {
            const blockType =
              blocks.blocksConfig[content[blocksFieldname]?.[block]?.['@type']];
            const isTitle = blockType?.['id'] === 'title';
            if (isTitle) {
              return <></>;
            }
            const Block = blockType?.['view'] || null;
            return Block !== null ? (
              <Block
                key={block}
                id={block}
                properties={content}
                data={content[blocksFieldname][block]}
              />
            ) : (
              <div key={block}>
                {intl.formatMessage(messages.unknownBlock, {
                  block: content[blocksFieldname]?.[block]?.['@type'],
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FolderBlockView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.object,
        image_caption: PropTypes.string,
        '@type': PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default injectIntl(FolderBlockView);
